import { useState, useEffect } from 'react';
import { fetchPlansDataPaged } from '../../../services/b2b-plans-apiService';
import { showNotification } from '../../b2b-common/Notification';
import { useLoginContext } from '../../../App';
import { useContentContext } from '../../layout/Layout';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const usePlansData = (elementsPerPage, currentPage=1) => {
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const { t } = useB2BTranslation('b2b-plans');

    const [organizationPlansData, setOrganizationPlansData] = useState(null);
    const [isSearching, setIsSearching] = useState(false);
    const [pagesCount, setPagesCount] = useState(1);
    const [currentPlansPage, setCurrentPlansPage] = useState(currentPage || 1);

    const gettingPlansData = async (page) => {
        const { accessToken } = loginData;
        setIsSearching(true);
        try {
            const response = await fetchPlansDataPaged(accessToken, true, page - 1, elementsPerPage);
            setCurrentPlansPage(page);
            setOrganizationPlansData(response);
            setPagesCount(response.totalPages);
        } catch (error) {
            console.error('Error fetching plans data:', error);
            console.log('Error current page:', page);
            console.log('Error elements per page:', elementsPerPage);
            showNotification(setNotification, t('Error fetching plans data: ') + error.message, 'error', 5000);
        } finally {
            setIsSearching(false);
        }
    }

    useEffect(() => {
        if (Number.isNaN(currentPlansPage) || !currentPlansPage || Number.isNaN(elementsPerPage)) 
            return;
        gettingPlansData(currentPlansPage);
    }, [currentPlansPage, loginData]);

    useEffect(() => {
        setCurrentPlansPage(currentPage);
    }, [currentPage]);

    return { organizationPlansData, setOrganizationPlansData, currentPlansPage, setCurrentPlansPage, isSearching, pagesCount };
};

export default usePlansData;